import { EParameterTypes } from "@/enums";

export const isRollDirectionParameter = (parameter: any) =>
  parameter?.parameterType === EParameterTypes.SELECT_FIXED_VALUES_WITH_IMAGES ||
  (parameter?.parameterType === EParameterTypes.DROP_DOWN_LIST &&
    !parameter?.setSettingIcon);

export const getRollDirectionImageUrl = (item: any): string | undefined => {
  if (item?.imageUrl) {
    return item.imageUrl;
  }
  const fromAttribute = item?.additionalAttribute?.find(
    (attr: any) => attr?.valueId === "image"
  )?.value;
  if (fromAttribute) {
    return fromAttribute;
  }
  return item?.rowData?.image?.value;
};

export const normalizeLang = (lang: unknown) => {
  const value = String(lang ?? "").trim();
  if (!value) {
    return "en";
  }
  return value.split("-")[0].toLowerCase();
};

export const getRollDirectionDisplayName = (item: any, lang: string) => {
  const normalized = normalizeLang(lang);
  const fromTranslation = Array.isArray(item?.translations)
    ? item.translations.find(
        (translation: any) => normalizeLang(translation?.lang) === normalized
      )?.name
    : undefined;
  if (fromTranslation?.trim()) {
    return fromTranslation;
  }
  return item?.updateName ?? "";
};

export const upsertRollDirectionTranslation = (
  translations: any,
  lang: string,
  name: string
) => {
  const normalized = normalizeLang(lang);
  const list = Array.isArray(translations) ? [...translations] : [];
  const index = list.findIndex(
    (translation) => normalizeLang(translation?.lang) === normalized
  );
  const entry = { lang: normalized, name };
  if (index >= 0) {
    list[index] = { ...list[index], ...entry };
  } else {
    list.push(entry);
  }
  return list;
};

export const mapRollDirectionValues = (
  valuesConfigs: any[] | undefined,
  lang?: string
) => {
  const source = Array.isArray(valuesConfigs)
    ? valuesConfigs.filter((item) => !item?.isDeleted)
    : [];
  const systemLang = normalizeLang(lang);

  return source.map((item, index) => ({
    ...item,
    id: item?.id || `roll-direction-${index}`,
    updateName: getRollDirectionDisplayName(item, systemLang),
    translations: Array.isArray(item?.translations) ? item.translations : null,
  }));
};
